import { CaseFilterRequest } from '../models/case-filter-request.model';
import { Injectable } from '@angular/core';
import { SortOrderType } from '@supoui/shared/model/enumerations/sort-order-type.model';
import { CasesFilter } from '../models/cases-filter.model';
import { CASES_ITEMS_PER_PAGE } from '@supoui/shared/constants/pagination.constants';
import moment from 'moment';
import { Observable, ReplaySubject, Subject, tap } from 'rxjs';
import { CaseFilterResponse } from '../models/case-filter-response.model';

@Injectable({
  providedIn: 'root'
})
export class FilterRequestService {
  caseFilterRequest: CaseFilterRequest;

  private casesPageMap: Map<string, Subject<CaseFilterResponse | Error>> = new Map<string, Subject<CaseFilterResponse | Error>>();
  private lastSearchFilter: Map<string, string> = new Map<string, string>();

  constructor() {
    this.init();
  }

  public init(): void {
    const fromDate = moment().add(-14, 'days').toDate();

    this.caseFilterRequest = new CaseFilterRequest({
      sortBy: 'caseCreatedOn',
      sortOrder: SortOrderType.desc,
      pageSize: CASES_ITEMS_PER_PAGE,
      pageIndex: 0,
      filter: new CasesFilter({fromDate})
    });
  }

  getPageCache(status: string): Observable<CaseFilterResponse> {
    let casesSubject = this.casesPageMap.get(status);
    if (!casesSubject) {
      casesSubject = new ReplaySubject<CaseFilterResponse | Error>(1);
      casesSubject.next({ totalNumber: 0, boardCaseDtoList: [] });
      this.casesPageMap.set(status, casesSubject);
    }
    return casesSubject.asObservable().pipe(
      tap((response: any) => {
        if (response instanceof Error) {
          throw response;
        }
      })
    );
  }

  setPageCache(status: string, page: CaseFilterResponse | Error) {
    if ( this.isSearchFilterChanged(status) ) {
      this.clearCacheEntry(status);
      this.updateLastSearchFilter(status);
    }
    let casesSubject = this.casesPageMap.get(status);
    if (!casesSubject) {
      casesSubject = new ReplaySubject<CaseFilterResponse | Error>(1);
      this.casesPageMap.set(status, casesSubject);
    }
    casesSubject.next(page);
  }

  isPageCached(status: string): boolean {
    return !this.isSearchFilterChanged(status) && !!this.casesPageMap.get(status);
  }

  resetPageCache() {
    this.casesPageMap = new Map<string, Subject<CaseFilterResponse | Error>>();
    this.lastSearchFilter = new Map<string, string>();
  }

  private clearCacheEntry(status: string) {
    this.casesPageMap.set(status, null);
  }
  
  private updateLastSearchFilter(status: string) {
    this.lastSearchFilter.set(status, JSON.stringify(this.caseFilterRequest.filter));
  }

  private isSearchFilterChanged(status: string) {
    return ( this.lastSearchFilter.get(status) !== JSON.stringify(this.caseFilterRequest.filter) );
  }
}
